import { createRedesignEntry } from "../redesign-page-entry";

export default createRedesignEntry(() => import("./change-password-page"), {
  testId: "rd-change-password-loading",
  // «Мой профиль» → «Сменить пароль».
  shell: {
    breadcrumbRoot: { id: "redesign.profile.title", defaultMessage: "My profile", to: "/pages/my_account" },
    breadcrumbLeaf: { id: "redesign.profile_edit.change_password", defaultMessage: "Change password" },
  },
});
